import { Flex } from '@backstage/ui';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import {
  EntityDependsOnComponentsCard,
  EntityDependsOnResourcesCard,
  EntityHasSubcomponentsCard,
  EntitySwitch,
  isKind,
} from '@backstage/plugin-catalog';
import { ConsumedApisCard, ProvidedApisCard } from '@backstage/plugin-api-docs';

export const entityContentArchitecture: ExtensionDefinition =
  EntityContentBlueprint.make({
    name: 'architecture',
    params: {
      path: '/architecture',
      title: 'Architecture',
      filter: {
        $any: [{ kind: 'Component' }, { kind: 'API' }],
      },
      loader: async () => (
        <Flex direction="column">
          <EntitySwitch>
            <EntitySwitch.Case if={isKind('component')}>
              <ProvidedApisCard />
              <ConsumedApisCard />
              <EntityDependsOnComponentsCard />
              <EntityDependsOnResourcesCard />
              <EntityHasSubcomponentsCard />
            </EntitySwitch.Case>
          </EntitySwitch>

          <EntitySwitch>
            <EntitySwitch.Case if={isKind('api')}>
              <EntityDependsOnComponentsCard />
              <EntityDependsOnResourcesCard />
            </EntitySwitch.Case>
          </EntitySwitch>

          <EntityCatalogGraphCard />
        </Flex>
      ),
    },
  });
